import { getGenSettings } from '@/api/methods/settings';
import { getLatestVersionInfo } from '@/api/methods/software';

export default {
  namespaced: true,
  state: {
    companyName: '',
    userName: '',
    userEmail: '',
    numberOfComputers: '',
    currentVersion: '8.9.0',
    latestVersion: '0.0.0',
    latestVersionTitle: '',
    latestVersionDescription: '',
    latestVersionLink: '',
    checkFrequency: 'every_startup',
    selectedDay: 5,
    isLatestVersion: false,
    isUpdateSoftware: false,
    isUserNotRegistered: false,
    dayTrial: 0,
  },
  getters: {
    companyName: (state) => state.companyName,
    userName: (state) => state.userName,
    userEmail: (state) => state.userEmail,
    numberOfComputers: (state) => state.numberOfComputers,
    currentVersion: (state) => state.currentVersion,
    latestVersion: (state) => state.latestVersion,
    latestVersionTitle: (state) => state.latestVersionTitle,
    latestVersionDescription: (state) => state.latestVersionDescription,
    latestVersionLink: (state) => state.latestVersionLink,
    checkFrequency: (state) => state.checkFrequency,
    selectedDay: (state) => state.selectedDay,
    isLatestVersion: (state) => state.latestVersion === state.currentVersion,
    isUpdateSoftware: (state) => state.isUpdateSoftware,
    isUserNotRegistered: (state) => state.isUserNotRegistered,
    dayTrial: (state) => state.dayTrial,
  },
  mutations: {
    setCompanyName: (state, payload) => {
      state.companyName = payload;
    },
    setUserName: (state, payload) => {
      state.userName = payload;
    },
    setUserEmail: (state, payload) => {
      state.userEmail = payload;
    },
    setNumberOfComputers: (state, payload) => {
      state.numberOfComputers = payload;
    },
    setCurrentVersion: (state, payload) => {
      state.currentVersion = payload;
    },
    setLatestVersion: (state, payload) => {
      state.latestVersion = payload;
    },
    setLatestVersionTitle: (state, payload) => {
      state.latestVersionTitle = payload;
    },
    setLatestVersionDescription: (state, payload) => {
      state.latestVersionDescription = payload;
    },
    setLatestVersionLink: (state, payload) => {
      state.latestVersionLink = payload;
    },
    setCheckFrequency: (state, payload) => {
      state.checkFrequency = payload;
    },
    setSelectedDay: (state, payload) => {
      state.selectedDay = payload;
    },
    setIsLatestVersion: (state, payload) => {
      state.isLatestVersion = payload;
    },
    setIsUpdateSoftware: (state, payload) => {
      state.isUpdateSoftware = payload;
    },
    setIsUserNotRegistered: (state, payload) => {
      state.isUserNotRegistered = payload;
    },
    setDayTrial: (state, payload) => {
      state.dayTrial = payload;
    },
  },
  actions: {
    updateCompanyInfo: async (store) => {
      const data = await getGenSettings();

      let numberOfComputers = null;

      if (!data[10]?.value) store.commit('setIsUserNotRegistered', true);

      if (data[6]?.value) store.commit('setCompanyName', data[6].value);

      if (data[7]?.value) store.commit('setUserName', data[7].value);

      if (data[8]?.value) store.commit('setUserEmail', data[8].value);

      if (data[9]?.value) store.commit('setDayTrial', data[9].value);

      if (data[5]?.value) numberOfComputers = Number(data[5].value);

      if (data[44]?.value === 'G7stRx') numberOfComputers += Number(data[47].value);

      if (numberOfComputers) store.commit('setNumberOfComputers', numberOfComputers);

      if (data[63]?.value) store.commit('setCurrentVersion', data[63].value);
    },
    updateSoftwareInfo: async (store) => {
      const data = await getLatestVersionInfo(store);
      if (!data) return null;
      const now = Date.now();
      sessionStorage.setItem('sessionUpdateCheck', now);
      if (data?.status === 404) {
        const { currentVersion } = store.getters;
        const latestVersion = currentVersion;
        store.commit('setLatestVersion', latestVersion);
        store.commit('setIsLatestVersion', latestVersion === currentVersion);
        return 404;
      }
      localStorage.setItem('lastUpdateCheck', now);
      const updates = data?.data?.updates[0];
      const latestVersion = `${updates.major}.${updates.minor}.${updates.patch}`;
      const latestVersionTitle = updates.text;
      const latestVersionDescription = data.data.features.sort((a, b) => b.weight - a.weight).map(({ title }) => title);
      const latestVersionLink = updates.current_url;
      store.commit('setLatestVersion', latestVersion);
      store.commit('setLatestVersionTitle', latestVersionTitle);
      store.commit('setLatestVersionDescription', latestVersionDescription);
      store.commit('setLatestVersionLink', latestVersionLink);
      const { currentVersion } = store.getters;
      store.commit('setIsLatestVersion', latestVersion === currentVersion);
      store.commit('setIsUpdateSoftware', true);
      return null;
    },
    updateCheckFrequency: ({ commit }, frequency) => {
      commit('setCheckFrequency', frequency);
      localStorage.setItem('checkFrequency', frequency);
    },
    updateSelectedDay: ({ commit }, value) => {
      commit('setSelectedDay', value);
      localStorage.setItem('selectedDay', value);
    },
    initializeCheckFrequency: ({ commit }) => {
      const storedValue = localStorage.getItem('checkFrequency');
      if (storedValue !== null) {
        commit('setCheckFrequency', storedValue);
      }
    },
    initializeSelectedDay: ({ commit }) => {
      const storedValue = localStorage.getItem('selectedDay');
      if (storedValue !== null) {
        commit('setSelectedDay', parseInt(storedValue, 10));
      }
    },
  },
};
